import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import '../../../App.css';
import '../../../css/bootstrap.scss';
import user_icon from "../../../images/reg_user.png";
import document_icon from "../../../images/document_icon.png";
import address_icon from "../../../images/address_icon.png";
import identity_icon from "../../../images/identity_icon.png";
import edit_icon from "../../../images/pencil_icon.png";
import questionnaire_icon from "../../../images/questionnaire_edit_icon.png";
import { useNavigate } from 'react-router-dom';
import Header from '../../Includes/Header';
import countriesStateData from '../../../data/states.json';
import BackButton from '../../Includes/BackButton';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import renderField from '../../renderField';
import { connect, useDispatch, useSelector } from 'react-redux';
import {
    setEmail,
    setphoneNo,
    setmiddleName,
    setfirstName,
    setlastName,
    setSelectedRegion,
    setstreetAddress,
    setcity,
    setpostalCode,
    setdriverLicenseNumber,
    setidentityCardNumber,
    setpassportNumber,
    setotherIdentityNumber,
    setotherDocumentNumber,
    setwizardPageNumber,
    setUserID,
} from '../../authslice';
import { RootState } from '../../store';
import countriesData from '../../../data/countries.json';
import axios, { AxiosError } from 'axios';
import config from '../../../config';
import { ToastBox, notifyError } from 'MyComponents/Toaster';
import { useTranslation } from 'react-i18next';
import HelpBtn from '../../Includes/HelpBtn';
import { getUserID } from 'Utils/user';
import { updatePersonalKycDraftStep } from 'Utils/personalKycDraft';

interface Props {}

interface FormData {
    phoneno: string;
    streetAddress: string;
    postalCode: string;
    city: string;
    firstName: string;
    lastName: string;
    middleName: string;
    documentNumber: string;
}

const renderPhoneField = ({ input, meta, phoneCode, ...rest }: any) => (
    <div className="mt-1">
        <div className={`input-group bg-white rounded-5 border ${meta.touched && meta.error ? 'border-danger' : ''} overflow-hidden`}>
            <span className="input-group-text bg-white border-0 py-2 ps-3 pe-1 text-secondary">
                +{phoneCode}
            </span>
            <input
                {...input}
                {...rest}
                className="form-control border-0 py-2 ps-0 shadow-none"
                style={{ outline: 'none' }}
            />
        </div>
        {meta.touched && meta.error && <p className="text-danger small mt-1 ps-2 mb-0 fw-bold">{meta.error}</p>}
    </div>
);

const RegistrationConfirmationForm: React.FC<Props & InjectedFormProps<{}, Props, FormData>> = (props: any) => {
    const { t } = useTranslation();
    const { handleSubmit } = props;
    const dispatch = useDispatch();

    const [selectedState, setSelectedState] = useState('');
    const [stateValidation, setStateValidation] = useState(false);

    const questionnaireScreen1 = useSelector((state: RootState) => state.auth.questionnaireScreen1);
    const armUpUsePurpose = questionnaireScreen1.join(', ');
    const questionnaireScreen2 = useSelector((state: RootState) => state.auth.questionnaireScreen2);
    const sourceOfFund = questionnaireScreen2.join(', ');
    const selectedIndustry = useSelector((state: RootState) => state.auth.questionnaireScreen3);
    const employmentStatus = useSelector((state: RootState) => state.auth.questionnaireScreen4);
    const accountActivityInfo = useSelector((state: RootState) => state.auth.questionnaireScreen5);
    const page = useSelector((state: RootState) => state.auth.wizardPageNumber);
    const countrySelected = useSelector((state: RootState) => state.auth.selectedCountryName);
    const selectedDocumentName = useSelector((state: RootState) => state.auth.selectedDocumentName);
    const region = useSelector((state: RootState) => state.auth.selectedRegionName);
    const dob = useSelector((state: RootState) => state.auth.dateofBirth);
    const firstNameState = useSelector((state: RootState) => state.auth.firstName);
    const lastNameState = useSelector((state: RootState) => state.auth.lastName);
    const selectedDocumentNumberDriverLicense = useSelector((state: RootState) => state.auth.selectedDocumentNumberDriverLicense);
    const selectedDocumentNumberIdentityCard = useSelector((state: RootState) => state.auth.selectedDocumentNumberIdentityCard);
    const selectedDocumentNumberPassport = useSelector((state: RootState) => state.auth.selectedDocumentNumberPassport);
    const selectedDocumentNumberOtherIdentity = useSelector((state: RootState) => state.auth.selectedDocumentNumberOtherIdentity);
    const selectedDocumentNumberOtherDocument = useSelector((state: RootState) => state.auth.selectedDocumentNumberOtherDocument);
    const email = useSelector((state: RootState) => state.auth.email);
    const phoneNoState = useSelector((state: RootState) => state.auth.phoneNo);
    const streetAddressState = useSelector((state: RootState) => state.auth.streetAddress);
    const cityState = useSelector((state: RootState) => state.auth.city);
    const postalCodeState = useSelector((state: RootState) => state.auth.postalCode);
    const middleNameState = useSelector((state: RootState) => state.auth.middleName);
    const userID = useSelector((state: RootState) => state.auth.userID);

    const formValues = useSelector((state: RootState) => (state.form.wizard as any)?.values || {});
    const syncErrors = useSelector((state: RootState) => (state.form.wizard as any)?.syncErrors);
    const submitFailed = useSelector((state: RootState) => (state.form.wizard as any)?.submitFailed);

    const [isEditingDocument, setIsEditingDocument] = useState(false);
    const [isEditingIdentity, setIsEditingIdentity] = useState(false);
    const [isEditingAddress, setIsEditingAddress] = useState(false);

    useEffect(() => {
        if (submitFailed) {
            const errors = syncErrors || {};
            if (errors.firstName || errors.lastName || errors.middleName || errors.phoneno) {
                setIsEditingIdentity(true);
            }
            if (errors.streetAddress || errors.city || errors.postalCode) {
                setIsEditingAddress(true);
            }
            if (errors.documentNumber) {
                setIsEditingDocument(true);
            }

            if (!selectedState) {
                setIsEditingAddress(true);
            }
        }
    }, [submitFailed, syncErrors, selectedState]);

    const [firstName, setFirstNameValue] = useState(firstNameState);
    const [lastName, setLastNameValue] = useState(lastNameState);

    const sendotp_baseURL = config.NODE_API_BASE_URL + '/twillio/sendSMSOTP';
    const saveAddressDetails_baseURL = config.NODE_API_BASE_URL + '/wso2/saveAddressDetails';

    useEffect(() => {
        if (region) {
            setSelectedState(region);
        }
    }, [region]);

    const sendOTP = async (phoneNo: string, country: string) => {
        try {
            const response = await axios.post(sendotp_baseURL, { phoneNo, country });
            return response?.data;
        } catch (error: any) {
            const axiosError = error as AxiosError;
            notifyError(axiosError.response?.status === 404 ? 'OTP Failed' : 'Something Went Wrong');
            console.error(error);
        }
    };

    const saveAddressDetails = async (streetAddress: string, postalCode: string, city: string, firstName: string, lastName: string, phoneNo: string) => {
        try {
            let currentUserID = userID;

            if (!currentUserID && email) {
                console.log("UserID missing in RegistrationConfirmationForm, resolving...");
                const resolvedID = await getUserID(email);
                if (resolvedID && resolvedID !== 0) {
                    currentUserID = resolvedID;
                    dispatch(setUserID(resolvedID));
                }
            }

            const response = await axios.post(saveAddressDetails_baseURL, {
                email,
                userId: currentUserID,
                country: countrySelected,
                streetAddress,
                postalCode,
                city,
                firstName: convertToCamelCase(firstName),
                lastName: convertToCamelCase(lastName),
                state: selectedState || '',
                phoneNo: phoneNo
            });
            return response?.data;
        } catch (error: any) {
            notifyError('Uploading Failed');
            console.error(error);
        }
    };

    const phoneCode = (countriesStateData as any[]).find((country) => country.name === countrySelected)?.phonecode;

    const submitForm = async (formValues: FormData) => {
        const { phoneno, streetAddress, postalCode, city, firstName, lastName, documentNumber, middleName } = formValues;

        if (!selectedState || !phoneno || !city || !firstName || !lastName || !streetAddress || !postalCode || !documentNumber) {
            if (!selectedState || !city || !streetAddress || !postalCode) {
                setIsEditingAddress(true);
                if (!selectedState) setStateValidation(true);
            }
            if (!phoneno || !firstName || !lastName) {
                setIsEditingIdentity(true);
            }
            if (!documentNumber) {
                setIsEditingDocument(true);
            }
            return;
        }

        dispatch(setphoneNo(phoneno));
        dispatch(setSelectedRegion(selectedState));
        dispatch(setfirstName(firstName));
        dispatch(setlastName(lastName));

        if (documentNumber) {
            if (selectedDocumentName === "Driving License") {
                dispatch(setdriverLicenseNumber(documentNumber));
            } else if (selectedDocumentName === "Passport") {
                dispatch(setpassportNumber(documentNumber));
            } else if (selectedDocumentName === "Identity Card") {
                dispatch(setidentityCardNumber(documentNumber));
            } else if (selectedDocumentName === "Other Identity") {
                dispatch(setotherIdentityNumber(documentNumber));
            } else {
                dispatch(setotherDocumentNumber(documentNumber));
            }
        }

        if (userID || email) {
            let currentUserID = userID;
            if (!currentUserID && email) {
                const resolvedID = await getUserID(email);
                if (resolvedID) currentUserID = resolvedID;
            }

            if (currentUserID) {
                updatePersonalKycDraftStep(currentUserID, 'confirmedDetails', {
                    firstName,
                    lastName,
                    middleName: middleName || '',
                    phoneno,
                    streetAddress,
                    city,
                    postalCode,
                    state: selectedState,
                    country: countrySelected,
                    dob,
                    documentNumber,
                    documentType: selectedDocumentName
                });
                updatePersonalKycDraftStep(currentUserID, 'wizardState', { pageNumber: page + 1 });
            }
        }

        const otpResponse = await sendOTP(phoneno, countrySelected);

        if (otpResponse?.status !== 1) {
            notifyError(otpResponse?.msg || "OTP sending failed. Please check your phone number.");
            return;
        }

        dispatch(setwizardPageNumber(page + 1));
        localStorage.setItem('pageNumber', `${page + 1}`);
    };

    const convertToCamelCase = (str: string) => {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    };

    return (
        <>
            <Container fluid className="px-0 px-md-3">
                <Row className="g-0">
                    <Col md={12} className="mx-auto px-2 pt-0 pb-3">
                        <div className="mt-5">
                            <Row className="px-2 px-md-5">
                                <Col md={12}><BackButton /></Col>
                            </Row>
                            <Row className="px-2 px-md-5">
                                <Col md={12}>
                                    <div className="d-flex align-items-start py-3">
                                        <img src={user_icon} width={48} className="d-none d-md-block me-3 mt-1" alt="User Icon" />
                                        <div>
                                            <h3 className="text-start m-0">{t('kyc.confirm_info')}</h3>
                                            <p className="fw-normal text-secondary m-0 mt-1">{t('kyc.confirm_secure')}</p>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="px-2 px-md-5">
                                <Col md={12}>
                                    <Form
                                        className="p-0"
                                        noValidate
                                        onSubmit={handleSubmit(submitForm)}
                                    >
                                        <div className="mb-2 d-flex align-items-center">
                                            <img src={document_icon} width={20} alt="doc icon" />
                                            <label className="fw-bold text-start m-0 px-2">
                                                {t('kyc.doc_info')}
                                            </label>
                                            {isEditingDocument ? (
                                                <Button
                                                    variant="primary"
                                                    size="sm"
                                                    className="rounded-5 px-3 py-1 ms-2"
                                                    onClick={() => {
                                                        if (formValues.documentNumber) {
                                                            if (selectedDocumentName === "Driving License") {
                                                                dispatch(setdriverLicenseNumber(formValues.documentNumber));
                                                            } else if (selectedDocumentName === "Passport") {
                                                                dispatch(setpassportNumber(formValues.documentNumber));
                                                            } else if (selectedDocumentName === "Identity Card") {
                                                                dispatch(setidentityCardNumber(formValues.documentNumber));
                                                            } else if (selectedDocumentName === "Other Identity") {
                                                                dispatch(setotherIdentityNumber(formValues.documentNumber));
                                                            } else {
                                                                dispatch(setotherDocumentNumber(formValues.documentNumber));
                                                            }
                                                            setIsEditingDocument(false);
                                                        } else {
                                                            props.touch('documentNumber');
                                                        }
                                                    }}
                                                >
                                                    {t('common.save')}
                                                </Button>
                                            ) : (
                                                <i
                                                    className="fa-solid fa-pencil text-secondary px-1 cursor-pointer"
                                                    onClick={() => setIsEditingDocument(true)}
                                                />
                                            )}
                                        </div>

                                        <Row className="mt-1">
                                            <Col md={4}>
                                                <label className="text-secondary small mb-0">{t('kyc.doc_type')}</label>
                                                <br />
                                                <label className="fw-bold custom_ConfirmReg_Label mb-0">
                                                    {selectedDocumentName}
                                                </label>
                                            </Col>
                                            <Col md={8}>
                                                <label className="text-secondary small mb-0">{t('kyc.doc_number')}</label>
                                                <br />
                                                {isEditingDocument ? (
                                                    <Field
                                                        name="documentNumber"
                                                        type="text"
                                                        component={renderField}
                                                        className="form-control rounded-5 mt-1"
                                                        placeholder={t('kyc.enter_doc_number')}
                                                        id="documentNumber"
                                                    />
                                                ) : (
                                                    <label className="fw-bold custom_ConfirmReg_Label mb-0">
                                                        {selectedDocumentNumberDriverLicense ||
                                                            selectedDocumentNumberIdentityCard ||
                                                            selectedDocumentNumberPassport ||
                                                            selectedDocumentNumberOtherIdentity ||
                                                            selectedDocumentNumberOtherDocument}
                                                    </label>
                                                )}
                                            </Col>
                                        </Row>

                                        <Row className="mt-2">
                                            <Col md={4}>
                                                <label className="text-secondary small mb-0">{t('kyc.country')}</label>
                                                <br />
                                                <label className="fw-bold custom_ConfirmReg_Label mb-0">
                                                    <img
                                                        src={countriesData.find((country) => country.name === countrySelected)?.image}
                                                        style={{ width: "20px", marginRight: "5px" }}
                                                        alt={countrySelected}
                                                    />
                                                    {countrySelected}
                                                </label>
                                            </Col>
                                            <Col md={8}>
                                                <label className="text-secondary small mb-0">{t('kyc.state')}</label>
                                                <br />
                                                <label className="fw-bold custom_ConfirmReg_Label mb-0">
                                                    {selectedState || region}
                                                </label>
                                            </Col>
                                        </Row>

                                        <div className="mb-2 mt-4 d-flex align-items-center">
                                            <img src={identity_icon} width={20} alt="identity icon" />
                                            <label className="fw-bold text-start m-0 px-2">
                                                {t('kyc.identity_info')}
                                            </label>
                                            {isEditingIdentity ? (
                                                <Button
                                                    variant="primary"
                                                    size="sm"
                                                    className="rounded-5 px-3 py-1 ms-2"
                                                    onClick={() => {
                                                        if (formValues.firstName && formValues.lastName && formValues.phoneno) {
                                                            dispatch(setfirstName(formValues.firstName));
                                                            dispatch(setlastName(formValues.lastName));
                                                            dispatch(setphoneNo(formValues.phoneno));
                                                            dispatch(setmiddleName(formValues.middleName || ''));
                                                            setIsEditingIdentity(false);
                                                        } else {
                                                            props.touch('firstName', 'lastName', 'phoneno');
                                                        }
                                                    }}
                                                >
                                                    {t('common.save')}
                                                </Button>
                                            ) : (
                                                <i
                                                    className="fa-solid fa-pencil text-secondary px-1 cursor-pointer"
                                                    onClick={() => setIsEditingIdentity(true)}
                                                />
                                            )}
                                        </div>

                                        <Row className="mt-2">
                                            <Col md={4}>
                                                <label className="text-secondary small mb-0">{t('kyc.first_name')}</label><br />
                                                {isEditingIdentity ? (
                                                    <Field
                                                        name="firstName"
                                                        type="text"
                                                        component={renderField}
                                                        className="form-control rounded-5 mt-1"
                                                        placeholder={t('kyc.first_name_ph')}
                                                        id="firstName"
                                                        required
                                                    />
                                                ) : (
                                                    <label className="fw-bold custom_ConfirmReg_Label mb-0">{firstName || firstNameState}</label>
                                                )}
                                            </Col>
                                            <Col md={4}>
                                                <label className="text-secondary small mb-0">{t('kyc.middle_name')}</label><br />
                                                {isEditingIdentity ? (
                                                    <Field
                                                        name="middleName"
                                                        type="text"
                                                        component={renderField}
                                                        className="form-control rounded-5 mt-1"
                                                        placeholder={t('kyc.middle_name_ph')}
                                                        id="middleName"
                                                    />
                                                ) : (
                                                    <label className="fw-bold custom_ConfirmReg_Label mb-0">{middleNameState || '---'}</label>
                                                )}
                                            </Col>
                                            <Col md={4}>
                                                <label className="text-secondary small mb-0">{t('kyc.last_name')}</label><br />
                                                {isEditingIdentity ? (
                                                    <Field
                                                        name="lastName"
                                                        type="text"
                                                        component={renderField}
                                                        className="form-control rounded-5 mt-1"
                                                        placeholder={t('kyc.last_name_ph')}
                                                        id="lastName"
                                                        required
                                                    />
                                                ) : (
                                                    <label className="fw-bold custom_ConfirmReg_Label mb-0">{lastName || lastNameState}</label>
                                                )}
                                            </Col>
                                        </Row>

                                        <Row className="mt-2">
                                            <Col md={4}>
                                                <label className="text-secondary small mb-0">{t('kyc.dob')}</label><br />
                                                <label className="fw-bold custom_ConfirmReg_Label mb-0">{dob}</label>
                                            </Col>
                                            <Col md={4}>
                                                <label className="text-secondary small mb-0">{t('kyc.phone_number')}</label><br />
                                                {isEditingIdentity ? (
                                                    <Field
                                                        name="phoneno"
                                                        type="text"
                                                        component={renderPhoneField}
                                                        phoneCode={phoneCode}
                                                        placeholder="300xxxxxxx"
                                                        id="phoneno"
                                                        required
                                                    />
                                                ) : (
                                                    <label className="fw-bold custom_ConfirmReg_Label mb-0">+{phoneCode} {phoneNoState}</label>
                                                )}
                                            </Col>
                                            <Col md={4}>
                                                <label className="text-secondary small mb-0">{t('kyc.email')}</label><br />
                                                <label className="fw-bold custom_ConfirmReg_Label mb-0">{email}</label>
                                            </Col>
                                        </Row>

                                        <div className="mb-2 mt-4 d-flex align-items-center">
                                            <img src={address_icon} width={20} alt="address icon" />
                                            <label className="fw-bold text-start m-0 px-2">{t('kyc.address_info')}</label>
                                            {isEditingAddress ? (
                                                <Button
                                                    variant="primary"
                                                    size="sm"
                                                    className="rounded-5 px-3 py-1 ms-2"
                                                    onClick={() => {
                                                        if (formValues.streetAddress && formValues.city && formValues.postalCode && selectedState) {
                                                            dispatch(setSelectedRegion(selectedState));
                                                            dispatch(setstreetAddress(formValues.streetAddress));
                                                            dispatch(setcity(formValues.city));
                                                            dispatch(setpostalCode(formValues.postalCode));
                                                            setIsEditingAddress(false);
                                                            setStateValidation(false);
                                                        } else {
                                                            props.touch('streetAddress', 'city', 'postalCode');
                                                            if (!selectedState) {
                                                                setStateValidation(true);
                                                            }
                                                        }
                                                    }}
                                                >
                                                    {t('common.save')}
                                                </Button>
                                            ) : (
                                                <i
                                                    className="fa-solid fa-pencil text-secondary px-1 cursor-pointer"
                                                    onClick={() => setIsEditingAddress(true)}
                                                />
                                            )}
                                        </div>

                                        <Row className="mt-1">
                                            <Col md={12}>
                                                <label className="text-secondary small mb-0">{t('kyc.street_address')}</label><br />
                                                {isEditingAddress ? (
                                                    <Field
                                                        name="streetAddress"
                                                        type="text"
                                                        component={renderField}
                                                        className="form-control rounded-5 mt-1"
                                                        placeholder={t('kyc.enter_street')}
                                                        id="streetAddress"
                                                    />
                                                ) : (
                                                    <label className="fw-bold custom_ConfirmReg_Label mb-0">{streetAddressState || '---'}</label>
                                                )}
                                            </Col>
                                        </Row>

                                        <Row className="mt-2">
                                            <Col md={4}>
                                                <label className="text-secondary small mb-0">{t('kyc.suburb_city')}</label><br />
                                                {isEditingAddress ? (
                                                    <Field
                                                        name="city"
                                                        type="text"
                                                        component={renderField}
                                                        className="form-control rounded-5 mt-1"
                                                        placeholder={t('kyc.enter_city')}
                                                        id="city"
                                                    />
                                                ) : (
                                                    <label className="fw-bold custom_ConfirmReg_Label mb-0">{cityState || '---'}</label>
                                                )}
                                            </Col>
                                            <Col md={8}>
                                                <label className="text-secondary small mb-0">{t('kyc.country_residence')}</label><br />
                                                <label className="fw-bold custom_ConfirmReg_Label mb-0">
                                                    <img
                                                        src={countriesData.find((country) => country.name === countrySelected)?.image}
                                                        style={{ width: '20px', marginRight: '5px' }}
                                                        alt={countrySelected}
                                                    />
                                                    {countrySelected}
                                                </label>
                                            </Col>
                                        </Row>

                                        <Row className="mt-2">
                                            <Col md={4}>
                                                <label className="text-secondary small mb-0">{t('kyc.state_province')}</label><br />
                                                {isEditingAddress ? (
                                                    <>
                                                        <div className="dropdown">
                                                            <Button
                                                                className={`bg-white text-secondary form-control form-select text-start px-3 rounded-5 border mt-1 ${stateValidation ? 'border-danger' : ''}`}
                                                                type="button"
                                                                data-bs-toggle="dropdown"
                                                                aria-expanded="false"
                                                                variant=""
                                                            >
                                                                {selectedState ? selectedState : t('kyc.select_state')}
                                                            </Button>
                                                            <ul className="dropdown-menu w-100 rounded-4 hide-scroll shadow border-0">
                                                                {countriesStateData.map((country) =>
                                                                    country.name === countrySelected
                                                                        ? country.states.map((state) => (
                                                                            <li key={state.id} className="dropdown-item" onClick={() => { setSelectedState(state.name); setStateValidation(false); }}>
                                                                                {state.name}
                                                                            </li>
                                                                        ))
                                                                        : null
                                                                )}
                                                            </ul>
                                                        </div>
                                                        {stateValidation && <p className="text-danger small mt-1 ps-2 mb-0 fw-bold">{t('kyc.state_required')}</p>}
                                                    </>
                                                ) : (
                                                    <label className="fw-bold custom_ConfirmReg_Label mb-0">{selectedState || region}</label>
                                                )}
                                            </Col>
                                            <Col md={4}>
                                                <label className="text-secondary small mb-0">{t('kyc.postal_code')}</label><br />
                                                {isEditingAddress ? (
                                                    <Field
                                                        name="postalCode"
                                                        type="text"
                                                        component={renderField}
                                                        className="form-control rounded-5 mt-1"
                                                        placeholder={t('kyc.enter_postal')}
                                                        id="postalCode"
                                                    />
                                                ) : (
                                                    <label className="fw-bold custom_ConfirmReg_Label mb-0">{postalCodeState || '---'}</label>
                                                )}
                                            </Col>
                                        </Row>

                                        <div className="mb-2 mt-4 d-flex align-items-center">
                                            <img src={questionnaire_icon} width={20} alt="questionnaire icon" />
                                            <label className="fw-bold text-start m-0 px-2">{t('kyc.questionnaire')}</label>
                                        </div>

                                        <Row className="mt-2">
                                            <Col md={4}>
                                                <label className="text-secondary small mb-0">{t('kyc.use_armf_q')}</label><br />
                                                <label className="fw-bold custom_ConfirmReg_Label mb-0">{armUpUsePurpose}</label>
                                            </Col>
                                            <Col md={4}>
                                                <label className="text-secondary small mb-0">{t('kyc.employment_q')}</label><br />
                                                <label className="fw-bold custom_ConfirmReg_Label mb-0">{employmentStatus}</label>
                                            </Col>
                                            <Col md={4}>
                                                <label className="text-secondary small mb-0">{t('kyc.industry_q')}</label><br />
                                                <label className="fw-bold custom_ConfirmReg_Label mb-0">{selectedIndustry}</label>
                                            </Col>
                                        </Row>
                                        <Row className="mt-2">
                                            <Col md={4}>
                                                <label className="text-secondary small mb-0">{t('kyc.source_funds_q')}</label><br />
                                                <label className="fw-bold custom_ConfirmReg_Label mb-0">{sourceOfFund}</label>
                                            </Col>
                                            <Col md={4}>
                                                <label className="text-secondary small mb-0">{t('kyc.account_activity_q')}</label><br />
                                                <label className="fw-bold custom_ConfirmReg_Label mb-0">{accountActivityInfo}</label>
                                            </Col>
                                        </Row>

                                        <div className="mt-5 d-flex gap-3">
                                            <Button
                                                className="btn btn-primary rounded-5"
                                                type="submit"
                                                style={{ width: "220px" }}
                                            >
                                                {t('common.continue')}
                                            </Button>
                                        </div>
                                    </Form>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Container>
            <HelpBtn />
        </>
    );
};

const mapStateToProps = (state: RootState) => ({
    initialValues: {
        phoneno: state.auth.phoneNo,
        streetAddress: state.auth.streetAddress || '',
        postalCode: state.auth.postalCode || '',
        city: state.auth.city || '',
        firstName: state.auth.firstName,
        lastName: state.auth.lastName,
        middleName: state.auth.middleName || '',
        documentNumber: state.auth.selectedDocumentNumberDriverLicense || state.auth.selectedDocumentNumberIdentityCard || state.auth.selectedDocumentNumberPassport || state.auth.selectedDocumentNumberOtherIdentity || state.auth.selectedDocumentNumberOtherDocument,
    },
});

const validate = (values: FormData) => {
    const errors: any = {};
    if (!values.firstName) {
        errors.firstName = 'First Name is required';
    }
    if (!values.lastName) {
        errors.lastName = 'Last Name is required';
    }
    if (!values.phoneno) {
        errors.phoneno = 'Phone Number is required';
    }
    if (!values.streetAddress) {
        errors.streetAddress = 'Street Address is required';
    }
    if (!values.city) {
        errors.city = 'City is required';
    }
    if (!values.postalCode) {
        errors.postalCode = 'Postal Code is required';
    }
    if (!values.documentNumber) {
        errors.documentNumber = 'Document Number is required';
    }
    return errors;
};

const form = reduxForm<{}, Props, FormData>({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    form: 'wizard',
    enableReinitialize: true,
    validate,
})(RegistrationConfirmationForm);

export default connect(mapStateToProps)(form);
